import { render, staticRenderFns } from "./questionEdit.vue?vue&type=template&id=88d5279e&scoped=true&"
import script from "./questionEdit.vue?vue&type=script&lang=js&"
export * from "./questionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d5279e",
  null
  
)

export default component.exports